import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetCoupon } from '../actions/packageSelection';
import { flagPurchaseEvent } from '../actions/pxpay';
import training from './../image/training_onsite.png';
import online from './../image/training_online.png';
import Cookies from 'universal-cookie';
import OrderSteps from './components/statusPage/orderSteps'
import { setDataLayer } from '../services/v2/dataLayer/dataLayerService';
import { redirectToUrl } from '../utils/navigation';

import './OrderStatusPage.css';

class OrderStatus extends Component {
  constructor(props) {
    super(props);

    //condition1 refers to order items other than report bundles
    //condition2 refers to order item report bundle
    //condition3 refers to multiple report bundle packages
    //condition4 refers to EMI-Premium
    this.state = {
      condition1: false,
      condition2: false,
      condition3: false,
      condition4: false,
      isInvestorTrial: false
    };

    //SERVICES
    this.analyticsPageView = this.props.SegmentAnalytics.analyticsPageView.bind(this);
    this.trackAction = this.props.SegmentAnalytics.trackAction.bind(this);
    this.trackGenericPageInfo = this.props.SegmentAnalytics.trackGenericPageInfo.bind(this);
    this.trackOrderStatus = this.props.SegmentAnalytics.trackOrderStatus.bind(this);
  }

  redirectToURL = (link, pageName) => {
    this.trackAction('Return to corporate site', 'Cotality home', pageName);
    redirectToUrl(link);
  };

  checkForInvestorTrial(quoteConfiguration, productId) {
    let products = quoteConfiguration.products;
    for (let index = 0; index < products.length; index++) {
      if (
        products[index].product_id === productId &&
        (products[index].configuration.industry === 'investors' || this.props.order?.customer?.industry === 'INVESTOR') &&
        products[index].configuration.package === 'trial'
      ) {
        this.setState({
          isInvestorTrial: true
        });
      }
    }
  }

  getPaidOrderItems(paidOrder) {
    let condition1 = false;
    let condition2 = false;
    let condition3 = false;
    let condition4 = false;
    if (paidOrder && Object.keys(paidOrder).length > 0) {
      let cartQuote = paidOrder.quotes.quotes;

      for (let index = 0; index < cartQuote.length; index++) {
        let quote = cartQuote[index];
        if (quote.type && quote.type === 'RPPRealEstate') {
          this.checkForInvestorTrial(paidOrder.quoteConfiguration, quote.productId);
        }
        if (quote.type !== null && quote.type === 'ReportBundle') {
          // if condition 2 is false and condition 3 is false it means its the first report bundle
          // if condition2 is true and condition 3 is false then this is the second report bundle
          // if condition2 is false and condition 3 is true then this is the third report bundle
          // no need to handle the third condition as the second condition handles anything more than 1
          if (!condition2 && !condition3) {
            condition2 = true;
          } else if (condition2 && !condition3) {
            condition3 = true;
          }
        }
        // if it is anything other than report bundle or emi then condition 1 is true
        if (
          quote.type !== null &&
          quote.type !== 'ReportBundle' &&
          quote.type !== 'EarlyMarketIndicator'
        ) {
          condition1 = true;
        }
        // if it is an emi product then condition 4 is true
        if (quote.type !== null && quote.type === 'EarlyMarketIndicator') {
          condition4 = true;
        }
      }
    }

    this.setState({
      condition1: condition1,
      condition2: condition2,
      condition3: condition3,
      condition4: condition4
    });
  }

  componentDidMount() {
    this.analyticsPageView('Order Status');

    let order;
    if (this.props.order && Object.keys(this.props.order).length > 0) {
      order = this.props.order;
    } else {
      order = this.props.paidOrder;
    }
    this.getPaidOrderItems(order);

    if (!this.props.isPurchaseEventFlagged) {
      //Track Order Status
      this.trackOrderStatus(order, 'Success', 'Order Successful', null, this.props.hmcw);
      this.props.flagPurchaseEvent();

      // Data Layer
      setDataLayer(order);
    }

    //reset coupon value after successful transaction
    this.props.resetCoupon();

    //Remove industry cookie on successful transaction
    const cookies = new Cookies();
    if (cookies.get('industry')) {
      cookies.remove('industry');
    }
  }

  render() {
    window.scrollTo(0, 0);
    return (
      <div>
        {this.props.paidOrder && (
          <div className='container'>
            <div className='row margin-bottom-100'>
              <div className='col-sm-12 text-white payment-status'>
                {this.props.paidOrder.total > 0 && (
                  <div className='row'>
                    <div className='col-sm-12'>
                      <div className='success-text padding-20 order-h3'>Success!</div>
                      <div className='captions'>
                        <p>
                          Thank you for your order.&nbsp;
                          {(this.state.condition1 || this.state.condition2 || this.condition3) && (
                            <span>
                              You will receive
                              {this.state.condition1 && <span> your login credentials </span>}
                              {this.state.condition1 &&
                                (this.state.condition2 || this.state.condition3) && (
                                  <span>and </span>
                                )}
                              {this.state.condition2 && <span> report </span>}
                              {this.state.condition3 && <span> reports </span>}
                              via email as soon as possible.&nbsp;
                            </span>
                          )}
                          {this.state.condition4 && (
                            <span>
                              {' '}
                              You are now subscribed to the Early Market Indicators Premium report
                              and will receive both the weekly reports and the monthly summary
                              report.&nbsp;{' '}
                            </span>
                          )}
                          If you have any questions, please contact our Customer Care team on{' '}
                          <b>1300 734318</b> and refer to{' '}
                          <b>
                            order #
                            {this.props.order && Object.keys(this.props.order).length > 0
                              ? this.props.order.orderNumber
                              : this.props.paidOrder.orderNumber}
                          </b>
                          .
                        </p>
                        <p>
                          When you join Cotality, you get free access to a network of professionals
                          who look after your interests long-term. Our friendly team will be in
                          touch.
                        </p>
                        <p>
                          You may now close this window or return to{' '}
                          <a
                            className='text-link'
                            onClick={() => {
                              this.redirectToURL('https://cotality.com/au', 'Success');
                            }}
                          >
                            cotality.com/au
                          </a>
                        </p>
                      </div>
                      {this.state.condition1 && (
                        <div className='row'>
                          <div className='col-sm-12'>
                            <div className='row'>
                              <div className='col-sm-2'>
                              </div>
                              <div className='col-sm-4'>
                                <div className='tile-container'>
                                  <div className='tile-top'>
                                    <img src={online} height='250' width='250' alt='Online' />
                                  </div>
                                  <div className='tile-content'>
                                    <div className='padding-10 text-left captions'>
                                      <p>
                                        Sign up to our free interactive online training courses.
                                        We offer beginner to advanced training across multiple products.
                                        Our online courses are ideal for ongoing training, as required.
                                      </p>
                                      <p>
                                        Link: <a className='text-link'
                                          target='_blank'
                                          rel='noopener noreferrer'
                                          href='https://campus.cotality.com/'>https://campus.cotality.com/
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='col-sm-4'>
                                <div className='tile-container'>
                                  <div className='tile-top'>
                                    <img src={training} height='250' width='250' alt='Onsite' />
                                  </div>
                                  <div className='tile-content'>
                                    <div className='padding-10 text-left body'>
                                      <p>
                                        Have one of our expert trainers work directly with you
                                        and your team to conduct specialised training.
                                      </p>
                                      <p>
                                        For more information on pricing call 1300
                                        734 318 or email{' '}
                                        <a
                                          className='text-link'
                                          href='mailto:campus@cotality.com'
                                        >
                                          campus@cotality.com
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {this.props.paidOrder && this.props.paidOrder.total === 0 && (
                  <div>
                    {!this.state.isInvestorTrial && (
                      <div className='row'>
                        <div className='col-sm-12 success-text padding-20 order-h3'>
                          Request Received
                        </div>
                        <div className='col-sm-12 body'>
                          <p>
                            Thank you for your interest in a Cotality product trial. You will
                            receive an email shortly confirming your trial request.
                          </p>
                          <p>
                            Once your request has been processed, you will recieve an email
                            invitation to connect to RP Data by the end of the next
                            business day.
                          </p>
                          <p>
                            If you have any questions, please contact our Customer Care team on{' '}
                            <b>1300 734 318</b> and refer to order #
                            {this.props.order && Object.keys(this.props.order).length > 0
                              ? this.props.order.orderNumber
                              : this.props.paidOrder.orderNumber}
                            .
                          </p>
                          <p>
                            You may now close this window or return to{' '}
                            <a
                              className='text-link'
                              onClick={() => {
                                this.redirectToURL('https://cotality.com/au');
                              }}
                            >
                              cotality.com/au
                            </a>
                          </p>
                        </div>
                      </div>
                    )}
                    {this.state.isInvestorTrial && (
                      <div className='row'>
                        <OrderSteps
                          order={this.props.order}
                          paidOrder={this.props.paidOrder}
                          isInvestorTrial={this.state.isInvestorTrial}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    directDebit: state.checkout.directDebit,
    trial: state.checkout.trial,
    paidOrder: state.cart.paidOrder,
    order: state.cart.order,
    hmcw: state.packageSelection.hmcw,
    isPurchaseEventFlagged: state.pxpay.isPurchaseEventFlagged
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetCoupon: () => dispatch(resetCoupon()),
    flagPurchaseEvent: () => dispatch(flagPurchaseEvent())
  };
};

let OrderStatusPage = connect(mapStateToProps, mapDispatchToProps)(OrderStatus);

export default OrderStatusPage;
